import { getTelemetryImplementation } from "@chainpatrol/telemetry";

import { env } from "./env";

export const telemetry = getTelemetryImplementation({
  appName: "chainpatrol-web",
  posthogApiKey: env.NEXT_PUBLIC_POSTHOG_API_KEY,
});
